import type { FC } from 'react';
import { Loader } from '@dynamon-as/ui';

const RouteLoader: FC = () => <Loader isLoading />;

export default RouteLoader;
